'use strict';

var cov_2l49a4lo9c = function () {
  var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/dirty.js',
      hash = 'c58195f990782665831323658ca5de9f865139a9',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/dirty.js',
    statementMap: {
      '0': {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 95,
          column: 16
        }
      },
      '1': {
        start: {
          line: 17,
          column: 0
        },
        end: {
          line: 95,
          column: 4
        }
      },
      '2': {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 94,
          column: 5
        }
      },
      '3': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 93,
          column: 11
        }
      },
      '4': {
        start: {
          line: 22,
          column: 25
        },
        end: {
          line: 22,
          column: 44
        }
      },
      '5': {
        start: {
          line: 23,
          column: 10
        },
        end: {
          line: 25,
          column: 13
        }
      },
      '6': {
        start: {
          line: 24,
          column: 12
        },
        end: {
          line: 24,
          column: 36
        }
      },
      '7': {
        start: {
          line: 46,
          column: 25
        },
        end: {
          line: 46,
          column: 39
        }
      },
      '8': {
        start: {
          line: 47,
          column: 10
        },
        end: {
          line: 60,
          column: 11
        }
      },
      '9': {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 72
        }
      },
      '10': {
        start: {
          line: 48,
          column: 59
        },
        end: {
          line: 48,
          column: 72
        }
      },
      '11': {
        start: {
          line: 49,
          column: 12
        },
        end: {
          line: 49,
          column: 51
        }
      },
      '12': {
        start: {
          line: 51,
          column: 26
        },
        end: {
          line: 51,
          column: 28
        }
      },
      '13': {
        start: {
          line: 52,
          column: 12
        },
        end: {
          line: 58,
          column: 13
        }
      },
      '14': {
        start: {
          line: 53,
          column: 14
        },
        end: {
          line: 57,
          column: 15
        }
      },
      '15': {
        start: {
          line: 54,
          column: 16
        },
        end: {
          line: 56,
          column: 17
        }
      },
      '16': {
        start: {
          line: 55,
          column: 18
        },
        end: {
          line: 55,
          column: 36
        }
      },
      '17': {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 27
        }
      },
      '18': {
        start: {
          line: 83,
          column: 10
        },
        end: {
          line: 92,
          column: 13
        }
      },
      '19': {
        start: {
          line: 84,
          column: 27
        },
        end: {
          line: 84,
          column: 41
        }
      },
      '20': {
        start: {
          line: 85,
          column: 12
        },
        end: {
          line: 91,
          column: 13
        }
      },
      '21': {
        start: {
          line: 86,
          column: 14
        },
        end: {
          line: 86,
          column: 44
        }
      },
      '22': {
        start: {
          line: 88,
          column: 14
        },
        end: {
          line: 90,
          column: 15
        }
      },
      '23': {
        start: {
          line: 89,
          column: 16
        },
        end: {
          line: 89,
          column: 75
        }
      },
      '24': {
        start: {
          line: 89,
          column: 49
        },
        end: {
          line: 89,
          column: 75
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 9,
            column: 1
          },
          end: {
            line: 9,
            column: 2
          }
        },
        loc: {
          start: {
            line: 9,
            column: 30
          },
          end: {
            line: 95,
            column: 5
          }
        },
        line: 9
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 17,
            column: 60
          },
          end: {
            line: 17,
            column: 61
          }
        },
        loc: {
          start: {
            line: 17,
            column: 78
          },
          end: {
            line: 95,
            column: 1
          }
        },
        line: 17
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 24
          }
        },
        loc: {
          start: {
            line: 19,
            column: 34
          },
          end: {
            line: 94,
            column: 3
          }
        },
        line: 19
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 20,
            column: 26
          },
          end: {
            line: 20,
            column: 27
          }
        },
        loc: {
          start: {
            line: 20,
            column: 46
          },
          end: {
            line: 26,
            column: 9
          }
        },
        line: 20
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 23,
            column: 21
          },
          end: {
            line: 23,
            column: 22
          }
        },
        loc: {
          start: {
            line: 23,
            column: 44
          },
          end: {
            line: 25,
            column: 11
          }
        },
        line: 23
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 45,
            column: 26
          },
          end: {
            line: 45,
            column: 27
          }
        },
        loc: {
          start: {
            line: 45,
            column: 42
          },
          end: {
            line: 61,
            column: 9
          }
        },
        line: 45
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 82,
            column: 28
          },
          end: {
            line: 82,
            column: 29
          }
        },
        loc: {
          start: {
            line: 82,
            column: 44
          },
          end: {
            line: 93,
            column: 9
          }
        },
        line: 82
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 83,
            column: 30
          },
          end: {
            line: 83,
            column: 31
          }
        },
        loc: {
          start: {
            line: 83,
            column: 41
          },
          end: {
            line: 92,
            column: 11
          }
        },
        line: 83
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 47,
            column: 10
          },
          end: {
            line: 60,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 47,
            column: 10
          },
          end: {
            line: 60,
            column: 11
          }
        }, {
          start: {
            line: 47,
            column: 10
          },
          end: {
            line: 60,
            column: 11
          }
        }],
        line: 47
      },
      '1': {
        loc: {
          start: {
            line: 48,
            column: 12
          },
          end: {
            line: 48,
            column: 72
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 48,
            column: 12
          },
          end: {
            line: 48,
            column: 72
          }
        }, {
          start: {
            line: 48,
            column: 12
          },
          end: {
            line: 48,
            column: 72
          }
        }],
        line: 48
      },
      '2': {
        loc: {
          start: {
            line: 48,
            column: 15
          },
          end: {
            line: 48,
            column: 57
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 48,
            column: 15
          },
          end: {
            line: 48,
            column: 24
          }
        }, {
          start: {
            line: 48,
            column: 28
          },
          end: {
            line: 48,
            column: 57
          }
        }],
        line: 48
      },
      '3': {
        loc: {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 58,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 58,
            column: 13
          }
        }, {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 58,
            column: 13
          }
        }],
        line: 52
      },
      '4': {
        loc: {
          start: {
            line: 54,
            column: 16
          },
          end: {
            line: 56,
            column: 17
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 54,
            column: 16
          },
          end: {
            line: 56,
            column: 17
          }
        }, {
          start: {
            line: 54,
            column: 16
          },
          end: {
            line: 56,
            column: 17
          }
        }],
        line: 54
      },
      '5': {
        loc: {
          start: {
            line: 54,
            column: 19
          },
          end: {
            line: 54,
            column: 78
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 54,
            column: 19
          },
          end: {
            line: 54,
            column: 47
          }
        }, {
          start: {
            line: 54,
            column: 51
          },
          end: {
            line: 54,
            column: 78
          }
        }],
        line: 54
      },
      '6': {
        loc: {
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 91,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 91,
            column: 13
          }
        }, {
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 91,
            column: 13
          }
        }],
        line: 85
      },
      '7': {
        loc: {
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 89,
            column: 75
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 89,
            column: 75
          }
        }, {
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 89,
            column: 75
          }
        }],
        line: 89
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2l49a4lo9c.s[0]++;
/**
 * API Bound Models for AngularJS
 * @version v1.1.11 - 2015-10-26
 * @link https://github.com/angular-platanus/restmod
 * @author Ignacio Baixas <ignacio@platan.us>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

(function (angular, undefined) {
  'use strict';
  /**
   * @mixin DirtyModel
   *
   * @description Adds the `$dirty` method to a model`s instances.
   */

  cov_2l49a4lo9c.f[0]++;
  cov_2l49a4lo9c.s[1]++;
  angular.module('restmod').factory('DirtyModel', ['restmod', function (restmod) {
    cov_2l49a4lo9c.f[1]++;
    cov_2l49a4lo9c.s[2]++;


    return restmod.mixin(function () {
      cov_2l49a4lo9c.f[2]++;
      cov_2l49a4lo9c.s[3]++;

      this.on('after-feed', function (_original) {
        cov_2l49a4lo9c.f[3]++;

        // store original information in a model's special property
        var original = (cov_2l49a4lo9c.s[4]++, this.$cmStatus = {});
        cov_2l49a4lo9c.s[5]++;
        this.$each(function (_value, _key) {
          cov_2l49a4lo9c.f[4]++;
          cov_2l49a4lo9c.s[6]++;

          original[_key] = _value;
        });
      })
      /**
       * @method $dirty
       * @memberof DirtyModel#
       *
       * @description Retrieves the model changes
       *
       * Property changes are determined using the strict equality operator.
       *
       * IDEA: allow changing the equality function per attribute.
       *
       * If given a property name, this method will return true if property has changed
       * or false if it has not.
       *
       * Called without arguments, this method will return a list of changed property names.
       *
       * @param {string} _prop Property to query
       * @return {boolean|array} Property state or array of changed properties
       */
      .define('$dirty', function (_prop) {
        cov_2l49a4lo9c.f[5]++;

        var original = (cov_2l49a4lo9c.s[7]++, this.$cmStatus);
        cov_2l49a4lo9c.s[8]++;
        if (_prop) {
          cov_2l49a4lo9c.b[0][0]++;
          cov_2l49a4lo9c.s[9]++;

          if ((cov_2l49a4lo9c.b[2][0]++, !original) || (cov_2l49a4lo9c.b[2][1]++, original[_prop] === undefined)) {
              cov_2l49a4lo9c.b[1][0]++;
              cov_2l49a4lo9c.s[10]++;
              return false;
            } else {
            cov_2l49a4lo9c.b[1][1]++;
          }cov_2l49a4lo9c.s[11]++;
          return original[_prop] !== this[_prop];
        } else {
          cov_2l49a4lo9c.b[0][1]++;

          var changes = (cov_2l49a4lo9c.s[12]++, []),
              key;
          cov_2l49a4lo9c.s[13]++;
          if (original) {
            cov_2l49a4lo9c.b[3][0]++;
            cov_2l49a4lo9c.s[14]++;

            for (key in original) {
              cov_2l49a4lo9c.s[15]++;

              if ((cov_2l49a4lo9c.b[5][0]++, original.hasOwnProperty(key)) && (cov_2l49a4lo9c.b[5][1]++, original[key] !== this[key])) {
                cov_2l49a4lo9c.b[4][0]++;
                cov_2l49a4lo9c.s[16]++;

                changes.push(key);
              } else {
                cov_2l49a4lo9c.b[4][1]++;
              }
            }
          } else {
            cov_2l49a4lo9c.b[3][1]++;
          }
          cov_2l49a4lo9c.s[17]++;
          return changes;
        }
      })
      /**
       * @method $restore
       * @memberof DirtyModel#
       *
       * @description Restores the model's last fetched values.
       *
       * Usage:
       *
       * ```javascript
       * bike = Bike.$create({ brand: 'Trek' });
       * // later on...
       * bike.brand = 'Giant';
       * bike.$restore();
       *
       * console.log(bike.brand); // outputs 'Trek'
       * ```
       *
       * @param {string} _prop If provided, only _prop is restored
       * @return {Model} self
       */
      .define('$restore', function (_prop) {
        cov_2l49a4lo9c.f[6]++;
        cov_2l49a4lo9c.s[18]++;

        return this.$action(function () {
          cov_2l49a4lo9c.f[7]++;

          var original = (cov_2l49a4lo9c.s[19]++, this.$cmStatus);
          cov_2l49a4lo9c.s[20]++;
          if (_prop) {
            cov_2l49a4lo9c.b[6][0]++;
            cov_2l49a4lo9c.s[21]++;

            this[_prop] = original[_prop];
          } else {
            cov_2l49a4lo9c.b[6][1]++;
            cov_2l49a4lo9c.s[22]++;

            for (var key in original) {
              cov_2l49a4lo9c.s[23]++;

              if (original.hasOwnProperty(key)) {
                  cov_2l49a4lo9c.b[7][0]++;
                  cov_2l49a4lo9c.s[24]++;
                  this[key] = original[key];
                } else {
                cov_2l49a4lo9c.b[7][1]++;
              }
            }
          }
        });
      });
    });
  }]);
})(angular);